import React, { useState, useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import {
  userLoginVerificationAsync,
  resendVerificationCodeAsync,
  AuthActions,
} from "../_redux";
import { OtpTimer } from '../../../../_metronic/layout/components/otp-timer';
import "./body.scss";

const initialValues = {
  code: "",
};
const addBodyClass = (className) =>
  document.body.classList.add("removeHeaderFooter");
const removeBodyClass = (className) =>
  document.body.classList.remove("removeHeaderFooter");
function Verification(props) {
  useEffect(() => {
    // Set up
    props.className instanceof Array
      ? props.className.map(addBodyClass)
      : addBodyClass("removeHeaderFooter");

    // Clean up
    return () => {
      props.ArrayclassName instanceof Array
        ? props.className.map(removeBodyClass)
        : removeBodyClass("removeHeaderFooter");
    };
  }, [props.className]);
  const { intl } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const [timeLeft, setTimeLeft] = useState(0);
  const { user, verificationField, isLoading } = useSelector(
    (state) => state.auth,
    shallowEqual
  );

useEffect(() => {
    if (timeLeft == 0) return  
   
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
      }, 1000);

      // if(timeLeft === 0) {
        // console.log('IIIIIIIIIIII', timeLeft);
        // alert('Kishan')
      // }
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  
  const LoginSchema = Yup.object().shape({
    code: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Please enter valid code."),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "isLoading-invalid";
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "isLoading-valid";
    }
    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values) => {

      if(verificationField === 'email') {
        let body = {
          code: values.code,
          emailId: user.emailId
        }
        dispatch(userLoginVerificationAsync({ body: body, id: user._id }));
      } else {
        let body = {
          code: values.code,
          contactNumber: user.contactNumber
        }
        dispatch(userLoginVerificationAsync({ body: body, id: user._id }));
      }
      

      
    },
  });

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  if (user.isOTPVerified && !user.isProfileSet) {
    return <Redirect to="/basic-information" />;
  }

  const resendCode = () => {
    setTimeLeft(60)
    dispatch(resendVerificationCodeAsync());
  };

  const redirectToLogin = () => {
    dispatch(AuthActions.resetAuthInitState());
    history.push("/login");
  };

  return (
    <>
      <div className="inner_main">
        <div className="row  w-100">
          <div className="col-xl-3 d-flex align-items-end justify-content-center d_none_1199">
            <div>
              <img
                alt=""
                className="img-fluid"
                src={toAbsoluteUrl("/media/others/developer-outline.png")}
              />
            </div>
          </div>
          <div className="col-xl-6">
            <div className="row">
              <div className="col-md-12 text-center mt-15 mb-10">
                <img
                  alt="Logo"
                  className="max-h-70px mb-5"
                  src={toAbsoluteUrl("/media/logos/auth_logo.png")}
                />
              </div>
              <div className="col-md-12">
                <div className="wt_box">
                  <div
                    className="login-form login-signin"
                    id="kt_login_signin_form"
                  >
                    <div className="text-center mb-10 mb-lg-15">
                      <img
                        alt="Logo"
                        className="max-h-70px mb-5"
                        src={toAbsoluteUrl("/media/others/verification_ic.svg")}
                      />
                      <h3 className="fn_s_32 color_blk f-w-500 mt-3">
                        Verification
                      </h3>
                      <p className="opacity60 fn_s_16 color_blk f-w-400">
                        Enter the security code we sent to your{" "}
                        {verificationField === "email"
                          ? "email Id"
                          : "contact number"}{" "}
                        :{" "}
                        {verificationField === "email"
                          ? user.emailId
                          : user.contactNumber}
                        .
                      </p>
                    </div>
                    <form
                      onSubmit={formik.handleSubmit}
                      className="form def_form"
                    >
                      <div className="form-group">
                        <label className="form-label">Security Code</label>
                        <div className="frpsswrd">
                          <input
                            placeholder="Password"
                            type={passwordShown ? "text" : "password"}
                            className={`form-control ${getInputClasses(
                              "password"
                            )}`}
                            name="code"
                            {...formik.getFieldProps("code")}
                          />
                          <i
                            onClick={togglePasswordVisiblity}
                            className="far fa-eye-slash"
                          ></i>
                        </div>
                        {formik.touched.code && formik.errors.code ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik.errors.code}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="form-group mb-0 mt-5">
                        <div className="row">
                          <div className="col-md-12 text-center mb-5">
                            <button
                              id="kt_login_signin_submit"
                              type="submit"
                              disabled={isLoading}
                              className={`btn btn-def ${!isLoading ? "defwtarw" : ""
                                }`}
                            >
                              <span>Continue</span>
                              {isLoading && (
                                <span className="ml-3 spinner spinner-white"></span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-md-12 text-center mt-10 bottom_links">
                <OtpTimer seconds={60} onResend={resendCode} />
              </div>
              <div className="col-md-12 text-center mt-10 bottom_links">
                <a
                  className="bckbtn fn_s_14 color_blk f-w-500 opacity50 uppercase"
                  onClick={() => redirectToLogin()}
                >
                  Back
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-3 d_none_1199">
            <img
              alt=""
              className="img-fluid mt-20"
              src={toAbsoluteUrl("/media/others/support-solid.png")}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default injectIntl(Verification);
